import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MobileDrawerComponent } from './mobile-drawer.component';

@NgModule({
    imports: [CommonModule],
    declarations: [MobileDrawerComponent],
    exports: [MobileDrawerComponent],
})
export class MobileDrawerModule {}
